import {
  LOGIN_USER_DATA_FAILURE,
  LOGIN_USER_DATA_REQUEST,
  LOGIN_USER_DATA_SUCCESS,
} from "../actions/actionTypes";
import loginService from "../service/login";

const user = loginService?.getDecodedToken()?.payload;

const initialState = {
  isFetchingData: false,
  checkEmptyRequest: null,
  user: user,
};

const login = (state, action) => {
  if (typeof state === "undefined") {
    return initialState;
  } else {
    switch (action.type) {
      case LOGIN_USER_DATA_REQUEST:
        return {
          ...state,
          isFetchingData: false,
          checkEmptyRequest: null,
        };
      case LOGIN_USER_DATA_SUCCESS:
        return {
          ...state,
          isFetchingData: true,
          user: action.payload,
        };
      case LOGIN_USER_DATA_FAILURE:
        return {
          ...state,
          isFetchingData: false,
          user: action.payload,
        };
      default:
        return state;
    }
  }
};

export default login;
